import { Tooltip } from '@components/ui/Tooltip';

function InfoIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 3C3.89543 3 3 3.89543 3 5V11C3 12.1046 3.89543 13 5 13H11C12.1046 13 13 12.1046 13 11V5C13 3.89543 12.1046 3 11 3H5ZM9 6C9 6.55228 8.55228 7 8 7C7.44772 7 7 6.55228 7 6C7 5.44772 7.44772 5 8 5C8.55228 5 9 5.44772 9 6ZM8 8C8.55228 8 9 8.44772 9 9V10C9 10.5523 8.55228 11 8 11C7.44772 11 7 10.5523 7 10V9C7 8.44772 7.44772 8 8 8Z"
        fill="currentColor"
      />
    </svg>
  );
}

interface IntoTipProps {
  label: string;
}

export function InfoTip({ label }: IntoTipProps) {
  return (
    <span>
      <Tooltip label={label}>
        <span className="text-tertiary hover:text-newGray-950">
          <InfoIcon />
        </span>
      </Tooltip>
    </span>
  );
}
